export default __webpack_public_path__ + "static/media/DAIF_Data_Screen2_In.cdeef84c.mp4";